import style from './incut-link.module.scss';
import Image from 'next/legacy/image';

interface LinkIncutProps {
  text: string;
  link: string;
}

const LinkIncut = ({ text, link }: LinkIncutProps) => {
  return (
    <a className={`${style.incut}`} href={link} target="_blank" rel="noreferrer">
      <div className={`${style.incut__image}`}>
        <Image width={106} height={28} src={'/icons/icn_logo.svg'} alt={'logo'} />
      </div>
      <div className={`${style.incut__text}`}>{text}</div>
    </a>
  );
};

export default LinkIncut;
